import { mapToBreakpoints } from '@koaly/mixins';

const getFlex = (values) => {
    return mapToBreakpoints(values, (value) => {
        if (value) {
            return 'display: flex;';
        }
        return '';
    });
};

export { getFlex };
//# sourceMappingURL=getFlex.js.map
